/*
 * Photo carousel for sections/floretta-carousel-text.liquid.
 * A scroll-snap track: swiping and trackpads work natively; the arrows and dots scroll the track.
 * Arrows wrap around at either end.
 */
if (!customElements.get("floretta-carousel")) {
  customElements.define(
    "floretta-carousel",
    class FlorettaCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector(".fct__track");
        this.slides = Array.from(this.querySelectorAll(".fct__slide"));
        this.dots = Array.from(this.querySelectorAll("[data-dot]"));
        if (!this.track || this.slides.length < 2) return;

        this.querySelector("[data-prev]")?.addEventListener("click", () => this.go(this.index() - 1));
        this.querySelector("[data-next]")?.addEventListener("click", () => this.go(this.index() + 1));
        this.dots.forEach((dot) =>
          dot.addEventListener("click", () => this.go(Number(dot.dataset.dot)))
        );
        this.track.addEventListener("scroll", () => this.update(), { passive: true });
        this.addEventListener("keydown", (event) => {
          if (event.key === "ArrowLeft") this.go(this.index() - 1);
          if (event.key === "ArrowRight") this.go(this.index() + 1);
        });
        this.update();
      }

      index() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      go(i) {
        const count = this.slides.length;
        const target = (i + count) % count;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: "smooth" });
      }

      update() {
        const current = this.index();
        this.dots.forEach((dot, i) => dot.setAttribute("aria-selected", String(i === current)));
      }
    }
  );
}
